import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { toast } from "react-toastify";

const UsersByRole = () => {
  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("/api_w/users", {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        const users = response.data.data || [];

        // Count by role
        const roleCounts = {
          superadmin: users.filter((u) => u.role === "superadmin").length,
          admin: users.filter((u) => u.role === "admin").length,
          user: users.filter((u) => u.role === "user").length,
        };

        setRoleData(roleCounts);
      } catch (error) {
        toast.error("Gagal memuat data pengguna");
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const chartOptions = {
    chart: {
      type: "donut",
      fontFamily: "Onest, sans-serif",
    },
    labels: ["Superadmin", "Admin", "User"],
    colors: ["#16a34a", "#4ade80", "#dcfce7"],
    stroke: {
      width: 0,
    },
    legend: {
      position: "bottom",
      fontSize: "13px",
      labels: {
        colors: "#a3aed0",
      },
      markers: {
        width: 12,
        height: 12,
        offsetX: -4,
      },
      itemMargin: {
        horizontal: 12,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "14px",
              color: "#a3aed0",
            },
            value: {
              show: true,
              fontSize: "20px",
              fontWeight: "700",
              color: "#1b2559",
              formatter: (val) => val,
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "14px",
              color: "#a3aed0",
              formatter: () =>
                roleData.superadmin + roleData.admin + roleData.user,
            },
          },
        },
      },
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (val) => `${val} pengguna`,
      },
    },
  };

  const chartSeries = [roleData.superadmin, roleData.admin, roleData.user];

  return (
    <div className="flex flex-col rounded-[20px] bg-white px-6 pb-4 pt-6 shadow-xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none">
      <h4 className="mb-4 text-lg font-bold text-navy-700 dark:text-white">
        Pengguna per Role
      </h4>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
        </div>
      ) : (
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="donut"
          height={300}
        />
      )}
    </div>
  );
};

export default UsersByRole;
